// extracted by mini-css-extract-plugin
export default {"root":"_1_aXV","label":"_1X-41"};